import { useQuery, UseQueryOptions } from 'react-query';
import { AvailableAssetPurchasesResponse, PurchasesProps } from '@24i/nxg-sdk-photon/src';
import { getRuntimeConfig } from '@24i/nxg-sdk-smartott/src/Application/initApp';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';
import { queryKeys } from '../queryKeys';

const useAvailableAssetPurchasesQuery = (
    asset: PurchasesProps,
    options?: UseQueryOptions<unknown, Error, AvailableAssetPurchasesResponse>
) => {
    const { fetchAvailableAssetPurchases } = usePurchaseData();
    const reactQuery = getRuntimeConfig('reactQuery');

    return useQuery<unknown, Error, AvailableAssetPurchasesResponse>(
        queryKeys.assetPurchases(asset?.id),
        () => fetchAvailableAssetPurchases(asset),
        {
            staleTime: reactQuery.staleTime.short,
            enabled: Boolean(asset),
            ...options,
        }
    );
};

export default useAvailableAssetPurchasesQuery;
